import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const deleteQuestionnaire = (id: number): AxiosPromise =>
  instance.delete(`/api/questionnaires/${id}`);

export default deleteQuestionnaire;
